import { render } from "./FavoriteIcon.vue?vue&type=template&id=0b9aa7a4&scoped=true"
import script from "./FavoriteIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon.vue?vue&type=script&lang=js"

import "./FavoriteIcon.vue?vue&type=style&index=0&id=0b9aa7a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9aa7a4"]])

export default __exports__